<template>
    <el-upload
        class="lnk-single-img-upload"
        name="uploadAttachment"
        auto-upload
        with-credentials
        appept="image/*"
        :data="uploadData"
        :headers="headers"
        :action="action"
        :show-file-list="false"
        :on-change="handleChange"
        :before-remove="handleBeforeRemove"
        :disabled="disabled"
        :on-error="handleUploadError"
        :on-progress="handleProgress"
        :on-success="handleUploadSuccess"
        :before-upload="handleBeforeUpload">
        <img v-if="!hideImg&&(imageUrl || privateImageUrl)" :src="imageUrl ? imageUrl : privateImageUrl" class="avatar" :style="sizeStyle">
        <i v-else-if="!imageUrl && !uploadPercentage"
           class="el-icon-plus uploader-border"
           :style="sizeStyle"><span style="font-size: 14px;">{{uploadTitle}}</span>
        </i>        <el-progress v-else type="circle"
                                 :percentage="uploadPercentage"
                                 :status="uploadStatus"
                                 :style="progressStyle"
                                 :width="progressWidth" >
    </el-progress>
    </el-upload>
</template>

<script>
/**
     * @name:图片上传组件
     * @createdby:yrf
     * @depend elementUI
     * @demo：<lnk-upload-img
     :head-id="headId"
     ui-type="rectangle"
     width="300"
     height="100"
     upload-title="选择图片"
     image-size="8192"
     module-type="SALE_CAMP"
     @uploadsuccess="uploadSuccess"
     >
     </lnk-upload-img>
     *      uploadSuccess: function(data){
     *          //获取附件id
                this.formData.attachmentId = data.newRow.id;
            },
     @head-id: 附件图片所属对象id（必填）
     @module-type: 附件所属对象业务编码 （必填）
     @ui-type：图片上传框风格，圆形：circle， 矩形：rectangle（默认）
     @width: 图片上传框宽度（直径），默认120
     @height：图片上传框高度：默认120
     @upload-title: 图片上传框内提示信息
     @image-size: 上传图片大小限制，默认2048（KB）
     @disabled：是否禁用 true/false（可用）
     @image-url: 要显示图片的URL
     @hide-img：是否隐藏图片的显示，true/false,默认false;设为true时，image-url将失效
     @uploadsuccess: 上传成功回调函数，参数为上传成功后服务端返回的对象
     */
export default {
    name: 'lnk-upload-img',
    props: {
        headid: {
            type: String,
            default: ' '
        },
        headId: {
            // 上传文件关联头id
            type: String,
            default: 'W-11111'
        },
        moduleType: {
            // 上传文件业务模块编码
            type: String,
            default: 'wxImage'
        },
        uiType: {
            // 文件上传框风格 circle / rectangle
            required: false,
            default: 'rectangle'
        },
        width: {
            // 文件上传框高度, 若是圆形则取宽度作为直径
            type: [Number, String],
            default: 120
        },
        height: {
            type: [Number, String],
            default: 120
        },
        imageSize: {
            type: [Number, String],
            default: 2048
        },
        hideImg: {
            type: Boolean,
            default: false
        },
        imageUrl: String,
        disabled: Boolean,
        uploadTitle: String,
        action: {
            type: String,
            default: () => appCtx.ctxPath + `/action/${LinkVue.prefixUrl}/attachment/insert` // 附件上传路径
        }
    },
    data: function(){
        return {
            headers: {
                // 文件上传请求头
                Authorization: linkToken.getLocalToken()
            },
            uploadData: {
                // 上传文件额外参数
                headId: this.headId, // 关联头id
                moduleType: this.moduleType // 业务模块类型
            },
            sizeStyle: {

                /* border: '1px dashed #d9d9d9',
                    fontSize: '24px',
                    color: '#8c939d',*/
                borderRadius: '6px'
            }, // 图片上传框样式
            progressStyle: {margin: '10px 10px'}, // 进度框样式
            progressWidth: 50, // 进度框宽度 --直径
            privateImageUrl: this.imageUrl, // 图片路径，privateImageUrl 为组件内图片变量，优先取父组件传入的图片变量，无则使用此路径变量，防止父组件上传图片后没有设置imageUrl
            uploadPercentage: 0, // 上传百分比
            uploadStatus: '', // 上传是否失败，失败时会设置为 exception
            CIRCLE: 'circle',
            RECTANGLE: 'rectangle'
        };
    },
    created: function(){
        if(this.uiType === this.CIRCLE){
            // 圆形
            this.sizeStyle.height = this.width + 'px';
            this.sizeStyle.width = this.width + 'px';
            this.sizeStyle.borderRadius = this.width / 2 + 'px';
            this.sizeStyle.lineHeight = this.width + 'px';
            if(this.width<100){
                this.progressWidth = this.width - 10;
                this.progressStyle.margin = '5px';
            }else{
                this.progressWidth = this.width >> 1;
                this.progressStyle.margin = (this.width >> 2) + 'px';
            }

        }else if(this.uiType === this.RECTANGLE){
            // 矩形
            this.sizeStyle.height = this.height + 'px';
            this.sizeStyle.width = this.width + 'px';
            this.sizeStyle.lineHeight = this.height + 'px';

            /** 计算进度框大小位置 */
            var d = (this.width > this.height ? this.height : this.width) - 20; // 直径 最小50才行, 所以宽高必须70
            var marginTop = (this.height - d) /2;
            var marginLeft = (this.width - d) /2;
            marginTop = marginTop > 0 ? marginTop : 0;
            marginLeft = marginLeft > 0 ? marginLeft : 0;
            this.progressWidth = d;
            this.progressStyle.margin = marginTop + 'px '+ marginLeft + 'px';
        }

    },
    mounted: function () {
    },
    watch: {
        headId: {
            immediate: true,
            handler: function () {
                this.uploadData.headId=this.headId;
            }
        },
        moduleType: {
            immediate: true,
            handler: function () {
                this.uploadData.moduleType=this.moduleType;
            }
        }

        /* editable: {
                immediate: true,

            }*/
    },
    methods: {
        handleBeforeUpload: function(file){
            // 上传前校验
            var isImg = file.type.indexOf('image/')>-1;
            var isLt2M = file.size / 1024 < this.imageSize;
            if (!isImg) {
                this.$nav.error('只能上传图片文件');
            }
            if (!isLt2M) {
                this.$nav.error('上传图片大小不能超过 '+this.imageSize+'KB!');
            }
            return isImg && isLt2M;
        },
        handleUploadSuccess: function(response, file){
            // 上传成功回调
            if(response.success === true){
                this.privateImageUrl = URL.createObjectURL(file.raw);
                this.uploadPercentage = 0;// 上传进度归零, 隐藏进度框
                response.imageUrl = this.privateImageUrl; // 返回本地图片路径，不要取服务器返回对象的attachmentPath,会导致重新加载
                this.$emit('uploadsuccess', response);
            } else{
                this.uploadStatus = 'exception';
                this.$nav.error('上传失败: '+response.result);
            }
            this.$emit('uploadfinish', response);
        },
        handleProgress: function(event, file){
            // 上传中 event.percent 百分比
            this.$emit('before-upload', file);// 上传之前清空之前的图片url
            this.uploadStatus = ''; // 上传状态置空,
            this.uploadPercentage = event.percent.toFixed(0);
            if(this.uploadPercentage > 99){
                this.uploadPercentage = 99.0;
            }
            this.privateImageUrl = '';
        },
        handleUploadError: function(err, file){
            // 上传失败
            this.$nav.error('上传失败');
            this.uploadStatus = 'exception';
        },

        handleChange: function(file){
            // console.log('on-change', !this.disabled);
        },
        handleBeforeRemove: function(file){
            // console.log('before-remove', !this.disabled);
            return true;
        }
    }
};
</script>

<style scoped>

</style>
